import { isEmpty } from 'lodash';
import getResolvedTicketPrice from './getResolvedTicketPrice';

/**
 * Selected (quantity > 0) ticket types with form state merged in.
 *
 * CAUTION — `price` is dual-mode: with `currency` passed it is the RESOLVED
 * per-ticket amount (for pwyw, the buyer-entered amount; blank → 0); without
 * `currency` it stays the stored ticket-type price (the pwyw minimum). The
 * stored price is always available as `originalPrice` — read that when you
 * mean the minimum, and pass `currency` when you mean the charged amount.
 */
export default function getSelectedTicketTypes(pageTicketGroups, formTicketGroups, currency) {
  if (!pageTicketGroups || !pageTicketGroups.length) return [];
  if (!formTicketGroups || isEmpty(formTicketGroups)) return [];

  const ticketGroups = Object.keys(formTicketGroups)
    .map(ticketGroupId => {
      const ticketGroup = pageTicketGroups.find(group => group._id === ticketGroupId);

      if (!ticketGroup) return null;

      const formTicketGroup = formTicketGroups[ticketGroupId];

      const selectedTicketTypes = formTicketGroup
        .map(formTicketType => {
          const ticketType = ticketGroup.ticketTypes.find(
            type => type._id === formTicketType.ticketTypeId,
          );

          if (!ticketType) return null;

          if (formTicketType.quantity === 0) return null;

          return {
            ...ticketType,
            ticketGroup: ticketGroup._id,
            feeDisplay: ticketGroup.feeDisplay || 'included',
            quantity: formTicketType.quantity,
            payWhatYouWantAmount: formTicketType.payWhatYouWantAmount,
            originalPrice: ticketType.price,
            ...(currency != null && {
              price: getResolvedTicketPrice(
                ticketType,
                formTicketType.payWhatYouWantAmount,
                currency,
              ),
            }),
          };
        })
        .filter(Boolean);

      return selectedTicketTypes;
    })
    .filter(Boolean);

  const selectedTicketTypes = ticketGroups.flat();

  return selectedTicketTypes;
}
